import { HardHat } from 'lucide-react';

import { Button } from './ui/button';
import { Sheet, SheetContent } from './ui/sheet';

/**
 * The handover code, shown once at pickup — in DEVELOPMENT BUILDS ONLY.
 *
 * `POST /pickup` mints the code and returns it exactly once, for the PLATFORM
 * to text to the customer. With no SMS provider contracted there is nothing
 * between that endpoint and this app, so during the pilot the rider is the
 * only one who ever sees it.
 *
 * That is precisely backwards — the code exists so the CUSTOMER can prove the
 * right bag reached the right door, and a rider who can read it can mark an
 * undelivered order delivered. So it is shown under the same rule as the
 * sign-in code, labelled for what it is, and compiled out of a release build.
 *
 * See `SHOW_HANDOVER_CODE` in lib/env.ts and the README.
 */
export function PickupCodeDialog({
  code,
  onDismiss,
}: {
  code: string | null;
  onDismiss: () => void;
}) {
  return (
    <Sheet open={code !== null} onOpenChange={(open) => !open && onDismiss()}>
      <SheetContent
        title="Development build"
        description="No SMS provider is wired up yet, so the customer will not receive their handover code. Read it out to them at the door."
      >
        <div className="grid justify-items-center gap-5 pb-2">
          <span className="grid size-12 place-items-center rounded-xl bg-warning-surface text-warning-ink">
            <HardHat className="size-6" aria-hidden="true" />
          </span>

          <p
            data-numeric
            className="text-5xl font-bold tracking-[0.25em] text-brand"
            // Read digit by digit rather than as "four thousand and twelve",
            // which is not what anyone says out loud at a door.
            aria-label={`Handover code: ${code?.split('').join(' ')}`}
          >
            {code}
          </p>

          <Button size="lg" block onClick={onDismiss}>
            Got it
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
